import React, { useMemo, useState } from 'react';
import Wizard from 'Components/wizard';
import WizardMainContainer from 'Components/wizard/WizardMainContainer';
import AddPracticeFirstStep from './steps/AddPracticeFirstStep';
import AddPracticeSecondStep from './steps/AddPracticeSecondStep';
const AddPractice = () => {
    const [loading] = useState(false);
    const makeSteps = useMemo(() => {
        return [
            {
                component: AddPracticeFirstStep,
                componentName: 'AddPracticeFirstStep',
            },
            {
                component: AddPracticeSecondStep,
                componentName: 'AddPracticeSecondStep',
            },
        ];
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(WizardMainContainer, null,
            React.createElement(Wizard, { steps: makeSteps, loading: loading }))));
};
export default AddPractice;
